"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RangeDatePicker = RangeDatePicker;
var _react = require("react");
var _hooks = require("../../../hooks");
var _dates = require("../../../utilities/dates");
var _Menu = require("../../Menu");
var _InlineView = require("./partials/InlineView");
var _DateTimePickers = require("../DateTimePickers.labels");
var _DateTimePickers2 = _interopRequireDefault(require("../DateTimePickers.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getValidProps = function getValidProps(props) {
  var minDateProp = props.minDate,
    maxDateProp = props.maxDate,
    startDateProp = props.startDate,
    endDateProp = props.endDate;
  var minDate = minDateProp && maxDateProp && minDateProp > maxDateProp ? maxDateProp : minDateProp;
  var startDate = startDateProp ? new Date(startDateProp) : undefined;
  var endDate = endDateProp ? new Date(endDateProp) : undefined;
  return _objectSpread(_objectSpread({}, props), {}, {
    minDate: minDate,
    startDate: startDate,
    endDate: endDate
  });
};
function RangeDatePicker(props) {
  var validProps = getValidProps(props);
  var _validProps$isDisable = validProps.isDisabled,
    isDisabled = _validProps$isDisable === void 0 ? false : _validProps$isDisable,
    startDate = validProps.startDate,
    endDate = validProps.endDate,
    onChange = validProps.onChange,
    btnProps = validProps.btnProps,
    _validProps$view = validProps.view,
    view = _validProps$view === void 0 ? 'inline' : _validProps$view,
    anchorSubTextStart = validProps.anchorSubTextStart,
    anchorSubTextEnd = validProps.anchorSubTextEnd,
    _validProps$attachedT = validProps.attachedTo,
    attachedTo = _validProps$attachedT === void 0 ? 'StartEndDates' : _validProps$attachedT;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var getLabel = (0, _hooks.useLabels)({
    labels: _DateTimePickers.labels
  });
  var styles = (0, _DateTimePickers2.default)(props);
  var startDateTimestamp = (0, _react.useRef)(startDate === null || startDate === void 0 ? void 0 : startDate.getTime());
  var endDateTimestamp = (0, _react.useRef)(endDate === null || endDate === void 0 ? void 0 : endDate.getTime());
  var _useState = (0, _react.useState)(startDate),
    _useState2 = _slicedToArray(_useState, 2),
    currentStartDate = _useState2[0],
    setCurrentStartDate = _useState2[1];
  var _useState3 = (0, _react.useState)(endDate),
    _useState4 = _slicedToArray(_useState3, 2),
    currentEndDate = _useState4[0],
    setCurrentEndDate = _useState4[1];
  var handleConfirm = function handleConfirm() {
    var confirmStartDate = currentStartDate !== null && currentStartDate !== void 0 ? currentStartDate : currentEndDate ? (0, _dates.getStartOfTheDay)(currentEndDate) : undefined;
    var confirmEndDate = currentEndDate !== null && currentEndDate !== void 0 ? currentEndDate : currentStartDate ? (0, _dates.getEndOfTheDay)(currentStartDate) : undefined;
    onChange(confirmStartDate, confirmEndDate);
  };
  var handleCancel = function handleCancel() {
    setCurrentStartDate(startDate);
    setCurrentEndDate(endDate);
  };
  var handleRangeDateChange = function handleRangeDateChange(start, end) {
    if (isDisabled) {
      return;
    }
    start = start ? (0, _dates.getStartOfTheDay)(start) : undefined;
    end = end ? (0, _dates.getEndOfTheDay)(end) : undefined;
    if (view === 'inline') {
      onChange(start, end);
    } else {
      setCurrentStartDate(start);
      setCurrentEndDate(end);
    }
  };
  (0, _react.useEffect)(function () {
    if (startDateTimestamp.current !== (startDate === null || startDate === void 0 ? void 0 : startDate.getTime()) || endDateTimestamp.current !== (endDate === null || endDate === void 0 ? void 0 : endDate.getTime())) {
      startDateTimestamp.current = startDate === null || startDate === void 0 ? void 0 : startDate.getTime();
      endDateTimestamp.current = endDate === null || endDate === void 0 ? void 0 : endDate.getTime();
      setCurrentStartDate(startDate);
      setCurrentEndDate(endDate);
    }
  }, [startDate, endDate]);
  var dataTestId = attachedTo === 'StartEndDates' ? 'select-StartEndDates' : attachedTo === 'StartDate' ? 'select-StartDate' : 'select-EndDate';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: view === 'inline' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_InlineView.InlineView, _objectSpread(_objectSpread({}, validProps), {}, {
      id: dataTestId,
      isDisabled: isDisabled,
      onChange: handleRangeDateChange
    })) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu.Menu, {
      id: dataTestId,
      btnProps: _objectSpread({
        color: 'basic',
        view: 'outlined',
        shape: isMobileView ? 'roundedRectangle' : 'ellipse',
        customStyle: isMobileView ? {
          width: '100%'
        } : {
          width: 'auto'
        },
        isDisabled: isDisabled,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: styles['cc-RangeDatePicker__anchor-btn'],
          children: [(attachedTo === 'StartDate' || attachedTo === 'StartEndDates') && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              children: startDate && /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
                children: (0, _dates.formatDate)(startDate, '{day}.{month}.{year}')
              })
            }), anchorSubTextStart && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              children: anchorSubTextStart
            })]
          }), attachedTo === 'StartEndDates' && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {}), (attachedTo === 'EndDate' || attachedTo === 'StartEndDates') && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              children: endDate && /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
                children: (0, _dates.formatDate)(endDate, '{day}.{month}.{year}')
              })
            }), anchorSubTextEnd && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              children: anchorSubTextEnd
            })]
          })]
        })
      }, btnProps),
      defaultTitle: attachedTo === 'StartDate' ? getLabel('choose') + anchorSubTextStart : attachedTo === 'EndDate' ? getLabel('choose') + anchorSubTextEnd : getLabel('choose_date'),
      isBoxCenteredToAnchor: true,
      anchorWidth: isMobileView ? 'auto' : 'fit-content',
      isWithActionButtons: true,
      isFullScreen: isMobileView,
      onConfirm: handleConfirm,
      onCancel: handleCancel,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InlineView.InlineView, _objectSpread(_objectSpread({}, validProps), {}, {
        isDisabled: isDisabled,
        startDate: currentStartDate,
        endDate: currentEndDate,
        onChange: handleRangeDateChange
      }))
    })
  });
}